module.exports = __webpack_public_path__ + "static/Prejoin_EN-a37593df894348f66eccdc2971bfa88a.pdf";